import PropTypes from 'prop-types';
import ChannelChipStrip from './channel-chip-strip';
import ChannelHeader from './channel-header';
import './communication-channels.scss';

const CommunicationChannels = ({
  brandColor, channels, profilePurposes, heading, helpText, onChannelToggle, visibleField, compact, chipsOnly,
}) => {
  const chipStrip = (
    <ChannelChipStrip
      brandColor={brandColor}
      channels={channels}
      profilePurposes={profilePurposes}
      onChannelToggle={onChannelToggle}
      visibleField={visibleField}
    />
  );

  if (chipsOnly) return chipStrip;

  const wrapperClass = compact
    ? 'bg-white border border-gray-200 rounded-lg px-3 py-2 flex items-center flex-wrap gap-x-3 gap-y-2'
    : 'mt-3 mb-3 bg-white border border-gray-200 rounded-lg p-3';

  return (
    <div className={wrapperClass}>
      <ChannelHeader heading={heading} helpText={helpText} compact={compact} />
      {chipStrip}
    </div>
  );
};

CommunicationChannels.propTypes = {
  brandColor: PropTypes.string.isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
  })).isRequired,
  profilePurposes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  heading: PropTypes.string,
  helpText: PropTypes.string,
  onChannelToggle: PropTypes.func,
  visibleField: PropTypes.string,
  compact: PropTypes.bool,
  chipsOnly: PropTypes.bool,
};

CommunicationChannels.defaultProps = {
  heading: '',
  helpText: '',
  onChannelToggle: () => {},
  visibleField: 'showInNotice',
  compact: false,
  chipsOnly: false,
};

export default CommunicationChannels;
